export enum DimensionUnit {
  Meter = 1,
  Feet = 2,
}
